import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbEnquete } from 'app/abstract/full-pages/enquete/enquete.abstract';
import { AppFilter } from 'app/models/app-filter.model';
import { EnqueteVoto } from 'app/models/enquete-voto.model';
import { Enquete } from 'app/models/enquete.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EnqueteService extends AbEnquete {

  public prefixo = "enquetes/"
  constructor(http: HttpClient) {
    super(http);
  }

  public getAllFilter(filter: AppFilter): Observable<any> {
    return this.get(`${this.prefixo}filter/${filter.encode()}`);
  }

  public getId(id: number): Observable<any> {
    return this.get(`${this.prefixo}${id}`);
  }

  public getVisualizarPorId(id: number): Observable<any> {
    return this.get(`${this.prefixo}visualizar/${id}`);
  }

  public getResultadoPorId(id: number): Observable<any> {
    return this.get(`${this.prefixo}resultado/${id}`);
  }

  public salvar(enquete: Enquete): Observable<any> {
    return this.save(`${this.prefixo}`, enquete);
  }

  public votar(voto: EnqueteVoto): Observable<any> {
    return this.post(`${this.prefixo}voto/`, voto);
  }

  public desativar(id: number) {
    return this.delete(`${this.prefixo}`, id);
  }

}
